import "./styles/globals.css";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { bootObservability } from "./observability";
import { installWordSyncCounter } from "./services/wordOpsLogger";

// The pane's own windows (review, Fix issues) open on this same page with
// ?window=…, so they load wherever the pane loads; they draw themselves.
const ownWindow = new URLSearchParams(window.location.search).get("window");
if (ownWindow === "review" || ownWindow === "fix") {
  void import("./review/main");
} else {
  bootPane();
}

function bootPane(): void {
  // Centralized logging — wire sinks once at app startup (SOLID/DIP).
  bootObservability();

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Root element #root not found");
  const root = ReactDOM.createRoot(rootEl);

  const render = () => {
    root.render(
      <React.StrictMode>
        <FluentProvider theme={webLightTheme}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </FluentProvider>
      </React.StrictMode>,
    );
  };

  // Initialize Office.js if available, otherwise render directly (dev mode)
  if (typeof Office !== "undefined" && Office.onReady) {
    Office.onReady(() => {
      // Count every context.sync — the unit of cost on Word desktop.
      installWordSyncCounter();
      render();
    });
  } else {
    render();
  }
}
